var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCemitLogoResponsive = function SvgCemitLogoResponsive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD952",
    d: "M16.502 15.8 0 0v10.889l16.502 16.477L33 10.889V0zM0 33h12.878L0 20.122zM20.122 33H33V20.122z"
  })));
};
export default SvgCemitLogoResponsive;